<template>
  <div class="dialog-wrap">
    <el-dialog
      title="进度日程"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      append-to-body
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="账号名称"
          prop="account_id"
        >
          <el-select
            v-model="dataForm.account_id"
            placeholder="请选择账号名称"
            clearable
            style="width:360px;"
          >
            <el-option
              v-for="(item,index) in $store.state.accountlist"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              {{item.name}}/{{formatePlatform_code(item.platform_code)}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选题名称"
          prop="topic_id"
        >
          <el-select
            v-model="dataForm.topic_id"
            placeholder="请选择选题名称"
            clearable
            style="width:360px;"
          >
            <el-option
              v-for="(item,index) in $store.state.mediatopiclist"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              {{item.name}}
              {{item.account_type_code?`(${formateType_code(item.account_type_code)})`:""}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="文案标题"
          prop="writing_id"
        >
          <el-select
            v-model="dataForm.writing_id"
            placeholder="请选择文案标题"
            clearable
            style="width:360px;"
          >
            <el-option
              v-for="(item,index) in $store.state.writinglist"
              :key="index"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否首条"
          prop="is_first"
        >
          <el-radio-group v-model="dataForm.is_first">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="定时"
          prop="is_timer"
        >
          <el-radio-group v-model="dataForm.is_timer">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="定时时间"
          prop="timer_time"
          v-if="dataForm.is_timer==1"
        >
          <el-date-picker
            v-model="dataForm.timer_time"
            type="datetime"
            placeholder="请选择日期时间"
            style="width:100%"
            clearable
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="发布人"
          prop="publish_user"
        >
          <el-input
            v-model="dataForm.publish_user"
            placeholder="请输入发布人"
          ></el-input>
          <!--   <el-select
            v-model="dataForm.publish_user"
            placeholder="请选择发布人"
            clearable
            style="width:360px;"
          >
            <el-option
              v-for="(item,index) in $store.state.adminList"
              :key="index"
              :label="item.nickname"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="dataForm.remark"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>


import { mediapublishCreate } from "@/api/select";
import { getStorage } from "@/utils/helper";



export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {

      },
      rules: {
        account_id: [{ required: true, message: '请选择账号', trigger: 'blur' }],
        topic_id: [{ required: true, message: '请选择选题', trigger: 'blur' }],
        writing_id: [{ required: true, message: '请选择文案', trigger: 'blur' }],
        is_timer: [{ required: true, message: '请是否定时', trigger: 'blur' }],
        is_first: [{ required: true, message: '请是否首条', trigger: 'blur' }],

        timer_time: [{ required: true, message: '请选择定时时间', trigger: 'blur' }],
        publish_user: [{ required: true, message: '请输入发布人', trigger: 'blur' }],
      },

    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.dataForm.publish_user = getStorage('admin_user').nickname
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let query = {
            account_id: this.dataForm.account_id,
            topic_id: this.dataForm.topic_id,
            writing_id: this.dataForm.writing_id,
            remark: this.dataForm.remark,
            publish_user: this.dataForm.publish_user,
            is_timer: this.dataForm.is_timer,
            is_first: this.dataForm.is_first,
            timer_time: this.dataForm.timer_time,
          }
          mediapublishCreate(query).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleClose() {
      this.$emit('close')
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*     4: "B站", */
        5: "知乎",
        /*         6: "抖音", */
      };
      return platform_code[val] || "";
    },
    formateType_code(val) {
      const type_code = {
        1: "机构",
        2: "课程",
        3: "学科",
        4: "院校",
      };
      return type_code[val] || "";
    },

  }
}
</script>

<style lang="less" scoped>
</style>
